import { TeamLearnerResponse } from 'api';
import { LICENSED_PRODUCTS_ABREV } from 'variables';
import { locale } from 'pages/Event/test-data/data';
import { TextV2 } from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { formatDateFromIsoString } from '@insights-ltd/design-library/utils';

const LatestProfileContainer = ({
  latestProfile,
  onClick,
  migrated = false,
  children,
}: {
  latestProfile: TeamLearnerResponse['latestProfile'];
  migrated?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}) => {
  if (
    (latestProfile?.profileType === 'DISCOVERY_PERSONAL_PROFILE' ||
      latestProfile?.profileType === 'IDTL_PROFILE' ||
      latestProfile?.profileType === 'DISCOVERY_PROFILE') &&
    onClick &&
    !migrated
  ) {
    return (
      <Button
        color="primary"
        variant="text"
        data-testid="profile-info-button"
        onClick={onClick}
        sx={(theme) => ({
          padding: '0 !important',
          height: theme.spacing(0.5),
          textAlign: 'left !important',
        })}
      >
        {children}
      </Button>
    );
  }

  return (
    <TextV2
      component="p"
      color="textSecondary"
      variant="bodyBold"
      data-testid="profile-info"
    >
      {children}
    </TextV2>
  );
};

export const LatestProfileText = ({
  latestProfile,
  latestEvaluation,
  onClick,
  migrated = false,
}: {
  latestProfile: TeamLearnerResponse['latestProfile'] | null;
  latestEvaluation: TeamLearnerResponse['latestEvaluation'] | null;
  onClick?: () => void;
  migrated?: boolean;
}) => {
  const { t } = useTranslation();

  if (latestProfile) {
    if (latestProfile.evaluation?.id === latestEvaluation?.id) {
      return (
        <LatestProfileContainer
          latestProfile={latestProfile}
          onClick={onClick}
          migrated={migrated}
        >
          {t('ui.event-management.learners.list.profile-date', {
            date: formatDateFromIsoString(latestProfile.createdAt, locale),
            product: latestProfile.profileType
              ? t(LICENSED_PRODUCTS_ABREV[latestProfile.profileType])
              : '',
          })}
        </LatestProfileContainer>
      );
    }
    return (
      <TextV2 variant="bodyBold" component="p" data-testid="profile-info">
        {t('ui.event-management.learners.list.profile-new-evaluation', {
          date: formatDateFromIsoString(
            latestEvaluation?.submittedOn ?? '',
            locale,
          ),
        })}
      </TextV2>
    );
  }

  if (!latestEvaluation) {
    return null;
  }

  return (
    <TextV2 variant="bodyBold" component="p" color="textSecondary">
      {t('ui.event-management.learners.list.profile-ready-to-purchase')}
    </TextV2>
  );
};
